<template>
  <div class="login-container d-flex align-items-center justify-content-center min-vh-100" :key="$i18n.locale">
    <div class="login-card card shadow p-4">
      <div class="text-center mb-3">
        <span class="ncb-logo-text brand-title">{{ $t('login.brand') }}</span>
        <h4 class="mb-0 welcome-title">{{ $t('login.welcome') }}</h4>
        <span class="mb-2 instruction-text">
          {{ $t('login.instruction') }}
        </span>
      </div>
      <div class="text-center mb-4">
        <button :disabled="loading" class="btn strava-btn btn-lg w-100 d-flex align-items-center justify-content-center" @click="login">
          <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/strava.svg" alt="Strava" class="strava-logo me-2" />
          <span class="strava-btn-text fw-bold" v-if="!loading">{{ $t('login.loginWithStrava') }}</span>
          <span v-else>
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            {{ $t('login.redirecting') }}
          </span>
        </button>
        <div v-if="error" class="alert alert-danger mt-2">{{ error }}</div>
      </div>
      <ul class="list-group mb-3">
        <li class="list-group-item d-flex align-items-center">
          <span class="step-number">1</span>
          <span>{{ $t('login.step1') }}</span>
        </li>
        <li class="list-group-item text-center">
          <img class="w-75 h-auto img-thumbnail" src="../assets/login-guide-new.png" :alt="$t('login.guideAlt')" />
        </li>
        <li class="list-group-item d-flex align-items-center">
          <span class="step-number">2</span>
          <span>{{ $t('login.step2') }}</span>
        </li>
        <li class="list-group-item d-flex align-items-center">
          <span class="step-number">3</span>
          <span>{{ $t('login.step3') }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import config from '../config'

export default {
  name: 'login',
  metaInfo () {
    return {
      title: this.$t('login.title')
    }
  },
  data () {
    return {
      resources: [],
      error: '',
      token: '',
      loading: false
    }
  },
  beforeMount () {
    if (/^\?fbclid=/.test(location.search)) {
      location.replace(location.href.replace(/\?fbclid.+/, ''))
    }
  },
  methods: {
    login (event) {
      this.loading = true
      const authUrl = config.getStravaAuthUrl('write')
      window.location.href = authUrl
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/sport-theme';

.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, $sport-foam 0%, $sport-mist 35%, rgba($sport-soft, 0.9) 72%, $sport-aqua 100%);
  position: relative;

  &::before {
    content: '🏃💨';
    position: absolute;
    top: 20px;
    left: 20px;
    font-size: 2rem;
    opacity: 0.55;
    animation: sportBounce 2s ease-in-out infinite;
  }

  &::after {
    content: '🏅';
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 2rem;
    opacity: 0.55;
    animation: sportBounce 2s ease-in-out infinite 0.5s;
  }

  @keyframes sportBounce {
    0%, 100% { transform: translateY(0) scale(1); }
    50% { transform: translateY(-8px) scale(1.1); }
  }
}
.login-card {
  max-width: 420px;
  width: 100%;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.95);
  border: 3px solid $sport-sky;
  box-shadow: 0 12px 40px rgba($sport-sky, 0.22);
}
.strava-btn {
  background: linear-gradient(135deg, $sport-deep 0%, $sport-primary 100%) !important;
  color: #fff !important;
  border: 2px solid $sport-sky;
  box-shadow: 0 6px 20px rgba($sport-deep, 0.28);
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  padding: 0.8rem 1.2rem;
  letter-spacing: 0.02em;
  border-radius: 12px;
}
.strava-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.strava-btn:hover:not(:disabled), .strava-btn:focus:not(:disabled) {
  background: linear-gradient(135deg, $sport-primary 0%, $sport-bright 100%) !important;
  color: #fff !important;
  box-shadow: 0 8px 28px rgba($sport-deep, 0.38);
  transform: translateY(-3px) scale(1.02);
  border-color: $sport-glow;
}
.strava-logo {
  width: 32px;
  height: 32px;
  margin-right: 12px;
  background: transparent;
  border-radius: 0;
  display: inline-block;
  filter: brightness(0) invert(1);
}
.strava-btn-text {
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.01em;
}
.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-right: 12px;
  background: linear-gradient(135deg, $sport-sky 0%, $sport-deep 100%);
  color: #fff;
  border-radius: 50%;
  font-weight: bold;
  font-size: 1.1rem;
  box-shadow: 0 4px 12px rgba($sport-sky, 0.35);
}
.ncb-logo-text.brand-title {
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 0.3rem;
  display: block;
  color: $sport-deep;
}
.welcome-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.2rem !important;
  color: $sport-primary;
}
.instruction-text {
  font-size: 0.92rem;
  color: $sport-primary;
  margin-bottom: 0.2rem;
  display: block;
}
.list-group-item {
  background: rgba(255, 255, 255, 0.85);
  border-color: rgba($sport-sky, 0.45);
  border-radius: 8px;
  margin-bottom: 4px;
}
@media (max-width: 600px) {
  .login-card {
    padding: 1rem !important;
    max-width: 98vw;
  }
  .w-75 {
    width: 100% !important;
  }
  .login-container {
    &::before, &::after {
      font-size: 1.5rem;
      top: 10px;
    }
    &::before { left: 10px; }
    &::after { right: 10px; }
  }
}
</style>
